// Action types for fetching Access Approval requests
export const FETCH_ACCESS_APPROVAL_REQUESTS_REQUEST = "FETCH_ACCESS_APPROVAL_REQUESTS_REQUEST";
export const FETCH_ACCESS_APPROVAL_REQUESTS_SUCCESS = "FETCH_ACCESS_APPROVAL_REQUESTS_SUCCESS";
export const FETCH_ACCESS_APPROVAL_REQUESTS_FAILURE = "FETCH_ACCESS_APPROVAL_REQUESTS_FAILURE";



// Action types for fetching access request by a user
export const FETCH_USER_ACCESS_REQUEST_REQUEST = 'FETCH_USER_ACCESS_REQUEST_REQUEST';
export const FETCH_USER_ACCESS_REQUEST_SUCCESS = 'FETCH_USER_ACCESS_REQUEST_SUCCESS';
export const FETCH_USER_ACCESS_REQUEST_FAILURE = 'FETCH_USER_ACCESS_REQUEST_FAILURE';



// Action types for fetching access request using requestId
export const FETCH_ACCESS_REQUEST_DETAILS_REQUEST = 'FETCH_ACCESS_REQUEST_DETAILS_REQUEST';
export const FETCH_ACCESS_REQUEST_DETAILS_SUCCESS = 'FETCH_ACCESS_REQUEST_DETAILS_SUCCESS';
export const FETCH_ACCESS_REQUEST_DETAILS_FAILURE = 'FETCH_ACCESS_REQUEST_DETAILS_FAILURE';



// Action types for requesting access to the platform
export const REQUEST_ACCESS_REQUEST = "REQUEST_ACCESS_REQUEST";
export const REQUEST_ACCESS_SUCCESS = "REQUEST_ACCESS_SUCCESS";
export const REQUEST_ACCESS_FAILURE = "REQUEST_ACCESS_FAILURE";


// Action types for approving access request
export const APPROVE_ACCESS_REQUEST_REQUEST = "APPROVE_ACCESS_REQUEST_REQUEST";
export const APPROVE_ACCESS_REQUEST_SUCCESS = "APPROVE_ACCESS_REQUEST_SUCCESS";
export const APPROVE_ACCESS_REQUEST_FAILURE = "APPROVE_ACCESS_REQUEST_FAILURE";



// Action types for rejecting access request
export const REJECT_ACCESS_REQUEST_REQUEST = "REJECT_ACCESS_REQUEST_REQUEST";
export const REJECT_ACCESS_REQUEST_SUCCESS = "REJECT_ACCESS_REQUEST_SUCCESS";
export const REJECT_ACCESS_REQUEST_FAILURE = "REJECT_ACCESS_REQUEST_FAILURE";